import { QueryKey } from '@tanstack/react-query';

export const couponQueryKeys = {
  /** 쿠폰 리스트 */
  couponList: (option: Record<string, unknown>): QueryKey => ['coupon', 'list', option],

  /** 쿠폰 상세 */
  couponDetail: (couponId: number): QueryKey => ['coupon', 'detail', couponId],

  /** 쿠폰 사용 내역 */
  couponUsageHistory: (couponId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'detail',
    couponId,
    'usageHistory',
    option,
  ],

  /** 쿠폰 미사용 내역 */
  couponUnUsageHistory: (couponId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'detail',
    couponId,
    'unUsageHistory',
    option,
  ],

  /** 쿠폰 상품 연결 */
  couponProductLink: (couponId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'detail',
    couponId,
    'productLink',
    option,
  ],

  /** 쿠폰 브랜드 연결 */
  couponBrandLink: (couponId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'detail',
    couponId,
    'brandLink',
    option,
  ],

  /** 쿠폰 적용 가능 상품 아이템 리스트 (생성/편집) */
  couponProductItemList: (option: Record<string, unknown>): QueryKey => ['coupon', 'productItem', option],

  /** 쿠폰 적용 가능 브랜드 아이템 리스트 (생성/편집) */
  couponBrandItemList: (option: Record<string, unknown>): QueryKey => ['coupon', 'brandItem', option],

  /** 쿠폰 발급 내역 리스트 */
  couponIssueHistoryList: (option: Record<string, unknown>): QueryKey => ['coupon', 'issueHistory', 'list', option],

  /** 쿠폰 발급 내역 상세 */
  couponIssueHistoryDetail: (issueHistoryId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'issueHistory',
    'detail',
    issueHistoryId,
    option,
  ],

  /** 쿠폰 발급 내역 상세 - 발급된 쿠폰 리스트 */
  couponGeneratedList: (issueHistoryId: number, option: Record<string, unknown>): QueryKey => [
    'coupon',
    'issueHistory',
    'detail',
    issueHistoryId,
    'generatedList',
    option,
  ],

  /** 쿠폰 발급 준비 */
  couponGeneratePreparation: (): QueryKey => ['coupon', 'generate', 'preparation'],

  /** 쿠폰 발급 - 검색 쿠폰 리스트 */
  couponGenerateSearchCouponList: (option: Record<string, unknown>): QueryKey => [
    'coupon',
    'generate',
    'searchCoupon',
    option,
  ],

  /** 쿠폰 발급 - 유저 리스트 */
  couponGenerateUserList: (option: Record<string, unknown>): QueryKey => ['coupon', 'generate', 'userList', option],

  /** 쿠폰 정보 (편집/복사용) */
  couponInfo: (couponId: number): QueryKey => ['coupon', 'info', couponId],
};
